import React, { useEffect, useState } from "react";
import { Menu } from "antd";
import { useNavigate, useLocation } from "react-router";
import plutosLogo from "../../assets/icons/plutosLogo.svg";
import CryptoJS from "crypto-js";
import "./Sidebar.scss";
import { useSelector } from "react-redux";
import decryptedModulesData from "../../utils/decryptedModulesData";

function Sidebar() {
  const navigate = useNavigate();
  const location = useLocation();
  const token = sessionStorage.getItem("biller_access");
  const permissionsLocalStorage = localStorage.getItem("module_access");
  const [selectedKey, setSelectedKey] = useState("/");
  const profileData = useSelector((state) => state.authReducer.profileData);

  const menuItems = [
    {
      label: "User",
      key: "/user",
      permission: "Users",
    },
    {
      label: "Transactions",
      key: "/transactions",
      permission: "Transactions",
    },
    // {
    //     label: "Billing Cycle",
    //     key: "/billing-cycle",
    //     permission: "billing_cycle"
    // },
    {
      label: "Customer Payment History",
      key: "/customer-payment-history",
      permission: "payment_history",
    },
    // {
    //     label: "SIMPL",
    //     key: "/simpl",
    //     permission: "SIMPL"
    // },
    {
      label: "Complaints",
      key: "/complaints",
      permission: "complaints",
    },

    {
      label: "Commision History",
      key: "/category",
      permission: "categories",
    },

    ...(profileData?.isEnrolledInPrepaidRecharge
      ? [
          {
            label: "Prepaid",
            key: "/prepaid",
            permission: "prepaid",
          },
        ]
      : []),

    // {
    //     label: "Customer Parameters",
    //     key: "/customer-parameters",
    //     permission: "customer_parameters"
    // },
    // {
    //     label: "Settlement Account",
    //     key: "/settlement-account",
    //     permission: "settlements"
    // },

    // {
    //     label: "Incentive Management",
    //     key: "/incentive-management",
    //     permission: "incentive_management"
    // },
    // {
    //     label: "Client Credential",
    //     key: "/client-Credential",
    //     permission: "client_credential"
    // },
    // {
    //     label: "Mails",
    //     key: "/mails",
    //     permission: "mails"
    // },
    // {
    //   label: "Help & Support",
    //   key: "/help-support",
    //   permission: "help-support",
    // },
  ];

  useEffect(() => {
    if (!token) {
      window.location.href = "/login";
      return null;
    }
    setSelectedKey(location.pathname);
  }, [token, location.pathname]);

  const permissions = decryptedModulesData()?.modules || [];

  // Filter out Activity Logs if not internal and not super admin
  const filteredMenuItems = [{ label: "Overview", key: "/" }, ...permissions];

  return (
    <div className="AppSidebar">
      <Menu
        selectedKeys={[selectedKey]}
        defaultSelectedKeys={["/"]}
        onClick={(item) => navigate(item.key)}
        items={
          Array.isArray(filteredMenuItems) &&
          filteredMenuItems?.map((item) => ({
            label: item?.label || item?.module,
            key: item?.key,
          }))
        }
      />
      <div className="plutos-logo">
        <img src={plutosLogo} alt="logo" />
      </div>
    </div>
  );
}

export default Sidebar;
